import { _forceFinishImportTask } from './ForceFinishImportTask';
import { _forceRemoveImportTableDefinition } from './ForceRemoveImportTableDefinition';

export namespace useAdmin {
  export const ForceFinishImportTask: typeof _forceFinishImportTask = _forceFinishImportTask;
  export const ForceRemoveImportTableDefinition: typeof _forceRemoveImportTableDefinition = _forceRemoveImportTableDefinition;
}
